var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react", "prop-types", "../../UI/Icon/ArteVertical", "./SearchTeaser.css"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"), require("prop-types"), require("../../UI/Icon/ArteVertical"), require("./SearchTeaser.css"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.ArteVertical, global.SearchTeaser);
    global.SearchTeaser = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react, _propTypes, _ArteVertical, _SearchTeaser) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _react = _interopRequireDefault(_react);
  _propTypes = _interopRequireDefault(_propTypes);
  _ArteVertical = _interopRequireDefault(_ArteVertical);

  var SearchTeaser = function SearchTeaser(_ref) {
    var className = _ref.className,
        bgColor = _ref.bgColor,
        image = _ref.image,
        title = _ref.title,
        tracking = _ref.tracking,
        url = _ref.url,
        withLogo = _ref.withLogo;
    return /*#__PURE__*/_react.default.createElement(_SearchTeaser.StyledContainer, {
      className: className
    }, /*#__PURE__*/_react.default.createElement(_SearchTeaser.StyledLink, {
      href: url,
      className: "".concat(className, "__link"),
      style: {
        backgroundColor: bgColor
      },
      onClick: tracking
    }, /*#__PURE__*/_react.default.createElement(_SearchTeaser.StyledBackground, {
      className: "".concat(className, "__picture"),
      style: {
        backgroundImage: image ? "url(".concat(image, ")") : ''
      }
    }), withLogo && /*#__PURE__*/_react.default.createElement(_SearchTeaser.StyledLogo, {
      className: "".concat(className, "__logo")
    }, /*#__PURE__*/_react.default.createElement(_ArteVertical.default, {
      size: {
        default: 'xxxsmall'
      }
    })), /*#__PURE__*/_react.default.createElement(_SearchTeaser.StyledTitle, {
      className: "".concat(className, "__title")
    }, title)));
  };

  SearchTeaser.propTypes = {
    bgColor: _propTypes.default.string,
    className: _propTypes.default.string,
    image: _propTypes.default.string,
    title: _propTypes.default.string.isRequired,
    tracking: _propTypes.default.func,
    url: _propTypes.default.string.isRequired,
    withLogo: _propTypes.default.bool
  };
  SearchTeaser.defaultProps = {
    className: 'next-search-teaser',
    tracking: function tracking() {},
    withLogo: false
  };
  var _default = SearchTeaser;
  _exports.default = _default;
});